// @flow

import CardMyLeague from './CardLeague'

export default CardMyLeague
